import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { HttpClient } from "@angular/common/http";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { AggregationConfig, DataAggregationService } from "src/app/services/data-aggregation.service";
import { FilterService } from "src/app/services/filter.service";
import { PageDataService } from "src/app/services/page-data.service";

@Component({
    selector: "app-slope-chart-card",
    templateUrl: "./slope-chart-card.component.html",
    styleUrls: ["./slope-chart-card.component.scss"],
    standalone: false
})
export class SlopeChartComponent implements OnInit, OnDestroy {
  static key = 100609;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  heading: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("slopeCharDiv", { static: true }) slopeCharDiv!: ElementRef;
  config: any;
  data: any;
  isDataLoaded = false;
  reqSubcription: Subscription[] = [];
  sourceName: any;
  error_name:any;
  private pageRawData: any[] = [];
  hasStartedLoading = false;

  constructor(
    private filterService: FilterService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private pageDataService: PageDataService,
    private dataAggregation: DataAggregationService
  ) {}

  ngOnInit(): void {
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.slopeCharDiv.nativeElement);
    this.loadlineConfig();

    this.reqSubcription.push(
      this.filterService.triggerNestedQuery.subscribe((query: any) => {
        if (query == this.item?.["widget_uniq_key"]) {
          if (this.pageDataService?.isActive) {
            this.rebuildFromPageData();
            return;
          }
          this.loadApiData();
        }
      }),
    );

    const cfg = this.item?.config;
    const dataMode = cfg?.['data_mode'] || 'widget'; // 'page' | 'widget'

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe(() => {
        // Only make independent API calls when PageDataService is NOT managing data
        if (!this.pageDataService?.isActive) {
          this.loadApiData();
        }
      })
    );
    
    if (this.pageDataService.isActive && dataMode === 'page') {
      // Page mode: data comes from centralized PageDataService.
      // Stay in loading state until the page service has actually started a load —
      // otherwise the BehaviorSubject's initial empty emission would flip the loader off.

      // Page mode: data comes from centralized PageDataService
      this.reqSubcription.push(
        this.pageDataService.loading$.subscribe((loading:any) => {
          if (loading) {
            this.isDataLoaded = false;
          }
        })
      );

      const listOfApi = cfg?.['list_of_api'];
      const apiKey = typeof listOfApi === 'string' || typeof listOfApi === 'number' ? listOfApi : listOfApi?.api_key;
      const stream$ = this.pageDataService.getDataStream(String(apiKey)) 

      this.reqSubcription.push(
        stream$.subscribe((res:any) => {
          // debugger
          if(this.filterService.isEmptyObject(this.filterService.baseQuery) == true)return;

          this.pageRawData = res || [];
          if (res && res.length > 0) {
            this.pageDataService.toggleData =  [...res];
            this.isDataLoaded = true;
            this.data = this.pageDataService.filterPageData(res);
            this.error_name = '';
          } else {
            this.pageDataService.toggleData =  [];
            this.data = [];
            this.error_name = '';
          }
        })
      );
    }
  }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
  }

  loadApiData(sourceName?: string) {
    // debugger
    // const cffg = this.item?.config;
    // if(cffg?.['AggregationEnabled'] == true){
    //   debugger
    //   const { groups, summary } = this.getAvgBusinessHours(this.data, cffg);
    //   this.data = groups;
    //   this.isDataLoaded = true;
    //   this.error_name = '';
    //   // console.log('Territory Map Avg Business Hours Data', this.data, summary);
    // } else {
      let api = this.item.config["list_of_api"] || {};
      if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
        
        // API Payload
        let obj:any = { "api_key" : api?.api_key || "100411" }
  
        let query = Object.assign({}, this.filterService.baseQuery, obj)
        query["report_typ"] = this.filterService.report_type || 'D';
        query['module_key'] = this.apiService.getModuleKey();
        let endPoint = this.item.config?.["list_of_api_endpoint"] || '';
  
        this.reqSubcription.push(
          this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query).subscribe((res:any)=> {
            this.isDataLoaded = true;
            this.pageDataService.toggleData =  [...res];
            if (this.pageDataService.isActive) {
              res = this.pageDataService.filterPageData(res);
            }

            this.data = (res && res?.length == 0) ? [] : res;
            this.error_name = '';
          },(err:any)=>{
            this.pageDataService.toggleData =  [];
            this.data = [];
            this.error_name = friendlyApiErrorMessage(err);
            console.error( "Slope Chart", err);
          })
        )
      // }
    }

  }
  
  getAvgBusinessHours(rows: any[], cfg: any) {
    const config: AggregationConfig = {
      groupBy:cfg['aggregation_groupBy'] ||'period',
      fields:cfg['aggregation_fields']||{
        total_bi_requests:   { source: 'total_bi_requests', op: 'sum' },
      },
      computed: cfg['aggregation_computed'] || { },
    };
    console.log(`Territory Map Props:${cfg.heading}`,config);
    const result = this.dataAggregation.aggregate(rows, config);
    return { groups: result.groups, summary: result.summary };
  }

  private rebuildFromPageData() {
    if (this.pageRawData?.length) {
      this.data = this.pageDataService.filterPageData(this.pageRawData);
      // this.buildView();
      this.error_name = '';
    } else {
      if(!this.hasStartedLoading) {
        this.hasStartedLoading = true;
        return;
      }
      this.data = [];
      this.error_name = '';
    }
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
